import React from 'react';
import { bool, shape, string } from 'prop-types';

const FieldWorksControl = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M7 16C8.34639 16 9.43943 16.8162 9.83691 18H22V20H9.83691C9.43943 21.1838 8.34639 22 7 22C5.65361 22 4.56057 21.1838 4.16309 20H2V18H4.16309C4.56057 16.8162 5.65361 16 7 16ZM7 18C6.4 18 6 18.4 6 19C6 19.6 6.4 20 7 20C7.6 20 8 19.6 8 19C8 18.4 7.6 18 7 18Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 9C13.3464 9 14.4394 9.81625 14.8369 11H22V13H14.8369C14.4394 14.1838 13.3464 15 12 15C10.6536 15 9.56057 14.1838 9.16309 13H2V11H9.16309C9.56057 9.81625 10.6536 9 12 9ZM12 11C11.4 11 11 11.4 11 12C11 12.6 11.4 13 12 13C12.6 13 13 12.6 13 12C13 11.4 12.6 11 12 11Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16 2C17.3464 2 18.4394 2.81625 18.8369 4H22V6H18.8369C18.4394 7.18375 17.3464 8 16 8C14.6536 8 13.5606 7.18375 13.1631 6H2V4H13.1631C13.5606 2.81625 14.6536 2 16 2ZM16 4C15.4 4 15 4.4 15 5C15 5.6 15.4 6 16 6C16.6 6 17 5.6 17 5C17 4.4 16.6 4 16 4Z" fill="currentColor" />
  </svg>
);

FieldWorksControl.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default FieldWorksControl;
